import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
const Subtitle = styled.div `
  margin-top: 24px;
`;
const ModalSectionsContainer = ({ sections }) => {
    const { t: translate } = useTranslation();
    const getItemsList = (items) => (<ul>
      {items === null || items === void 0 ? void 0 : items.map((item, index) => <li key={index}>{translate(item)}</li>)}
    </ul>);
    return (<>
      {sections.map((section, index) => (<div key={index}>
          <Subtitle>{translate(section.header)}</Subtitle>
          {getItemsList(section.items)}
        </div>))}
    </>);
};
export default ModalSectionsContainer;
